import { ClientConfigService } from '../services/client-config.service';

type HotjarConfig = { enabled: boolean; id: number | string; sv: number };
type HotjarStub = ((...args: unknown[]) => void) & { q?: unknown[][] };

declare global {
  interface Window {
    hj: HotjarStub;
    _hjSettings: { hjid: number | string; hjsv: number };
  }
}

function createHotjarStub(): HotjarStub {
  const stub: HotjarStub = function (...args: unknown[]) {
    stub.q ??= [];
    stub.q.push(args);
  };
  return stub;
}

function loadHotjarScript(config: HotjarConfig, resolve: () => void): void {
  window.hj = createHotjarStub();
  window._hjSettings = { hjid: config.id, hjsv: config.sv };
  const hjUrl = `https://static.hotjar.com/c/hotjar-${window._hjSettings.hjid}.js?sv=${window._hjSettings.hjsv}`;
  const head = document.getElementsByTagName('head')[0];
  const scriptEl = document.createElement('script');
  scriptEl.async = true;
  scriptEl.src = hjUrl;
  head.appendChild(scriptEl);
  scriptEl.addEventListener('load', () => {
    console.debug('HotJar loaded successfully', config);
    resolve();
  });
  scriptEl.addEventListener('error', (event: Event) => {
    console.debug('HotJar not loaded', config, event);
    resolve();
  });
}

export function hotJarInit(clientConfigService: ClientConfigService) {
  return (): Promise<void> => {
    return new Promise<void>(resolve => {
      clientConfigService.hotjar().subscribe((config: HotjarConfig) => {
        if (config.enabled === true) {
          loadHotjarScript(config, resolve);
        } else {
          console.debug('HotJar disabled', config);
          resolve();
        }
      });
    });
  };
}
